import { render, staticRenderFns } from "./list.vue?vue&type=template&id=703f8dea&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f8dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703f8dea')) {
      api.createRecord('703f8dea', component.options)
    } else {
      api.reload('703f8dea', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=703f8dea&scoped=true", function () {
      api.rerender('703f8dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/articleclass/list.vue"
export default component.exports